import { render, staticRenderFns } from "./CargarPlantilla.vue?vue&type=template&id=71ed6228&scoped=true"
import script from "./CargarPlantilla.vue?vue&type=script&lang=js"
export * from "./CargarPlantilla.vue?vue&type=script&lang=js"
import style0 from "./CargarPlantilla.vue?vue&type=style&index=0&id=71ed6228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed6228",
  null
  
)

export default component.exports